import { ChangeEvent } from 'react';

import { getFormattedCurrency, getFormattedFloatNumber } from 'utils';

export const handlePriceChange = (
  setPrice: React.Dispatch<React.SetStateAction<string | undefined>>,
  onChange?: (value: number | string) => void,
) => (e: ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value.replaceAll(',', '');
  const number = getFormattedFloatNumber(value);

  setPrice(value);
  onChange?.(number);
};

export const handlePriceBlur = (
  setPrice: React.Dispatch<React.SetStateAction<string | undefined>>,
) => (e: ChangeEvent<HTMLInputElement>) => {
  const { value } = e.target;
  const number = getFormattedFloatNumber(value);
  const price = getFormattedCurrency(number);

  setPrice(price);
};
